export default "__VITE_ASSET__CbmybDey__"